import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'; // Import DataGrid
import { investorApi } from "../../api/api";


const Banner = () => {
    const [loading, setLoading] = useState(true);  // Track loading state
    const [openDialog, setOpenDialog] = useState(false); // State to control modal visibility
    const [selectedImage, setSelectedImage] = useState('/logo192.png'); // Default local image URL
    const [rows, setRows] = React.useState([]); // Define the rows state
    const navigate = useNavigate();

    const handleAction = () => {
        // Fixed the navigate URL for proper routing
        navigate('/banner/bannerdetails'); // Make sure this is the correct route for your details page
    };

    useEffect(() => {
        const getBannerData = async () => {
          setLoading(true);  // Set loading to true initially
          try {
           
            const response = await investorApi.getBannerData();
    
            // Check if the response data is an array
            if (Array.isArray(response.data)) {
                setRows(response.data);  // Set data if it's an array
            } else {
              console.error('API response is not an array');
              setRows([]);  // Set an empty array if response is not as expected
            }
          } catch (error) {
            console.error('Error fetching data:', error);
            setRows([]);  // If error, set empty array
          } finally {
            setLoading(false);  // Stop loading after the fetch attempt (whether successful or not)
          }
        };
        getBannerData();
      }, []);
    

      const formattedData = rows.map((item) => ({
        id: item.id,   // Ensure every row has a unique `id`
        ContentId: item.id,
        PropertyType: item.type === 1 ? 'Project' : 'Property',  
        Name: `Project ${item.ContentId}`,  
        ImageUrl: item.imageUrl || '/images/placeholder.jpg',  
    }));
    
    // Open modal with larger image
    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpenDialog(true);  // Open the dialog/modal
    };

    // Close the modal
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedImage(null); // Reset the selected image when modal is closed
    };

    const columns = [
        { field: "ContentId", headerName: "ID", width: 70 },
        {
            field: "PropertyType",
            headerName: "Property type",
            width: 300,
        },
        {
            field: "Name",
            headerName: "Project Name",
            width: 300,
        },
        {
            field: "ImageUrl", // Display the image in the IconUrl field
            headerName: "Icon",
            width: 100,
            renderCell: (params) => (
                <img
                    src={params.value || '/images/your-image.jpg'} // Local image fallback
                    alt="Project Icon"
                    style={{ width: "50px", height: "50px", borderRadius: "5px", cursor: "pointer" }}
                    onClick={() => handleImageClick(params.value)} // Open modal on click
                />
            ),
        },
    ];

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 4, px: 2 }}>
            <div className="dashboard section_space_bottom">
                <Box sx={{ flexGrow: 1 }} style={{ border: '2px solid lightgray', borderRadius: '5px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <h1 style={{ margin: '20px 20px' }}>Banner</h1>
                        </Grid>
                        <Grid item xs={4} container justifyContent="flex-end">
                            <Button variant="contained" style={{
                                height: '40px',
                                marginTop: '30px',
                                marginRight: '20px'
                            }} onClick={handleAction}>Add New</Button>
                        </Grid>
                    </Grid>
                </Box>
                <div style={{ height: 400, width: '150vh' }}>
                <DataGrid
    rows={formattedData}
    columns={columns}
    pageSize={5}
    rowsPerPageOptions={[5, 10, 25]}
    getRowId={formattedData.id}  // Use custom row id
    disableSelectionOnClick
    autoHeight={false}
    sx={{
      '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#00796b',
      color: 'white',
      fontWeight: 'bold',
    },
    }}
/>

                </div>
            </div>

            {/* Modal for viewing the image */}
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="sm" // This will increase the width of the modal
                fullWidth // Ensures the modal takes full width as specified
            >
                <DialogTitle>Project Icon</DialogTitle>
                <DialogContent
                    style={{
                        display: 'flex',
                        justifyContent: 'center',  // Center image horizontally
                        alignItems: 'center',  // Center image vertically
                    }}
                >
                    <img
                        src={selectedImage} // Display the selected image in the modal
                        alt="Selected Icon"
                        style={{
                            maxWidth: '100%',  // Make image responsive to the modal width
                            maxHeight: '80vh',  // Ensure the image doesn't overflow vertically
                            borderRadius: '5px',
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Banner;